import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Text,
  Card,
  CardBody,
  VStack,
  HStack,
  Button,
} from '@chakra-ui/react';
import { FiBarChart2, FiTag } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import BundlingProductTab from '../components/BundlingProductTab';
import ReportingTab from '../components/ReportingTab';
import IeemWorkspaceTabs from '../components/IeemWorkspaceTabs';
import EmptyStateBlock from '../components/bundling/EmptyStateBlock';
import PageHeader from '../components/bundling/PageHeader';
import SarinahCouponBrowser from '../components/SarinahCouponBrowser';

const Retail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedRole, user } = useAuth();
  
  // Determine active tab based on route - hanya untuk IEEM sub menu
  const isIeemRoute = location.pathname.includes('/retail/ieem') || location.pathname === '/admin/retail/ieem';
  const isBundlingProductRoute = location.pathname.includes('/retail/bundling-product') || location.pathname === '/admin/retail/bundling-product';
  const isCouponsRoute = location.pathname.includes('/retail/sarinah-coupons') || location.pathname === '/admin/retail/sarinah-coupons';
  
  // Tab hanya untuk IEEM: How to Publish dan List Product
  const [activeIeemTab, setActiveIeemTab] = useState(0);
  
  // Update active tab when route changes
  useEffect(() => {
    if (location.pathname === '/admin/retail/ieem' || location.pathname === '/admin/retail') {
      // Default redirect to IEEM if no sub route specified
      navigate('/admin/retail/ieem', { replace: true });
    }
  }, [location.pathname, navigate]);

  // Check user role
  const userRole = user?.role || '';
  let parsedUserRoles = [];
  if (userRole) {
    if (Array.isArray(userRole)) {
      parsedUserRoles = userRole;
    } else if (typeof userRole === 'string') {
      if (userRole.includes(';')) {
        parsedUserRoles = userRole.split(';').map(r => r.trim()).filter(r => r);
      } else if (userRole.includes(',')) {
        parsedUserRoles = userRole.split(',').map(r => r.trim()).filter(r => r);
      } else if (userRole.trim()) {
        parsedUserRoles = [userRole.trim()];
      }
    }
  }
  
  const hasRoleIeem = selectedRole === 'ieem' || (!selectedRole && parsedUserRoles.includes('ieem'));
  const hasRoleBp = selectedRole === 'bp' || (!selectedRole && parsedUserRoles.includes('bp'));

  // Mapping IEMMPUBLISH_MEMBER
  const getMemberCode = () => 'srn';

  const eyebrow = isIeemRoute ? 'IEEM Workspace' : isBundlingProductRoute ? 'Product Workspace' : 'Domain Workspace';

  return (
    <Box>
      <VStack align="stretch" spacing={4} mb={6}>
        <PageHeader
          eyebrow={eyebrow}
          title="Injourney Retail"
          description="Kelola IEEM publishing, bundling product, dan integrasi data transaksi Retail."
          secondaryActions={(
            <HStack spacing={2}>
              <Button
                as={Link}
                to="/admin/retail/integrationData"
                leftIcon={<FiBarChart2 />}
                size="sm"
                variant="outline"
                colorScheme="blue"
              >
                Integration Data
              </Button>
              <Button
                as={Link}
                to="/admin/retail/sarinah-coupons"
                leftIcon={<FiTag />}
                size="sm"
                variant="outline"
                colorScheme="orange"
              >
                Sarinah Coupons
              </Button>
            </HStack>
          )}
        />
      </VStack>

      <Card bg="white" borderRadius="16px" boxShadow="sm">
        <CardBody p={{ base: 2, lg: 4 }}>
          {/* Hanya tampilkan tab jika di route IEEM */}
          {isIeemRoute && hasRoleIeem ? (
            <IeemWorkspaceTabs
              activeIeemTab={activeIeemTab}
              onTabChange={setActiveIeemTab}
              memberCode={getMemberCode()}
              productsContent={
                <EmptyStateBlock
                  title="Products workspace akan segera tersedia"
                  description="Daftar product readiness untuk InJourney Retail akan ditampilkan di sini."
                />
              }
              analyticsContent={<ReportingTab />}
            />
          ) : isBundlingProductRoute && hasRoleBp ? (
            // Bundling Product route
            <BundlingProductTab memberId="srn" />
          ) : isCouponsRoute ? (
            // Sarinah Coupons route
            <SarinahCouponBrowser />
          ) : (
            // Default - redirect ke IEEM
            <VStack align="stretch" spacing={4}>
              <Text color="gray.600">
                Memuat...
              </Text>
            </VStack>
          )}
        </CardBody>
      </Card>
    </Box>
  );
};

export default Retail;
